import { Component, Input } from '@angular/core';

import { isSituacaoAtiva, isSituacaoInativa } from '../natureza-venda-situacao';

@Component({
    selector: 'sgt-natureza-venda-situacao-badge',
    templateUrl: './natureza-venda-situacao-badge.component.html',
    styleUrls: ['./natureza-venda-situacao-badge.component.less']
})
export class NaturezaVendaSituacaoBadgeComponent {
    /** Situação da natureza de venda */
    @Input() situacao: number;

    /** Verifica se a situação da natureza de venda é Ativa */
    isSituacaoAtiva(): boolean {
        return isSituacaoAtiva(this.situacao);
    }

    /** Verifica se a situação da natureza de venda é Inativa */
    isSituacaoInativa(): boolean {
        return isSituacaoInativa(this.situacao);
    }
}
